<template>
  <div :class="[$style.profile_css, $style.target_profile_height]">
    <div :class="$style['Profile']">
      <div :style="!isLoaded ? 'opacity : 0' : 'opacity : unset'"
           :class="[$style.headerProfile, $style.center_cropped_main]">
        <div :class="$style['profileAvatar']">
          <div :class="$style['logoProfile']">
            <img v-if="profile == null" :class="$style['border_r']"
                 :src="require('../assets/image/cluna/app_logo.png')"/>
            <img v-else :class="$style['center_cropped']"
                 :src="(profile.user_avatar == null
                              ? require('../assets/image/avatar.jpg') : profile.user_avatar)"/>
          </div>
          <label for="uploaduser" :class="$style['uploadAvatar']" v-if="profile != null">
            <v-icon>camera</v-icon>
          </label>
          <input
              :class="$style['uploaduser']"
              type="file"
              accept="image/*"
              id="uploaduser"
              @change="onFileChange"
          />
        </div>
        <div :class="$style['textProfile']" v-if="profile != null">
          <h6>
            {{ profile.username }}
          </h6>
          <span class="font-weight-bold">{{ profile.phone }}</span>
        </div>
        <div :class="$style['registrProfile']" v-else>
          <v-btn role="button" v-ripple @click="modalLogin = true"
                 style="background-color: #7ec352; border-radius: 20px; color: #fff">
            ورود / ایجاد حساب کاربری
          </v-btn>
        </div>
        <div v-if="profile == null" style="text-align: center; display: flex;justify-content: center;">
          <p style="width: 70%; font-size: 14px">
            برای استفاده کامل از امکانات برنامه حساب کاربری خود را فعال کنید</p>
        </div>

        <div :class="$style['increase-credit']" v-if="profile != null">
          <p>
            اعتبار
            <span class="font-weight-bold"
                  style="font-size: 18px !important;">{{ oracle.format(profile.user_wallet) }}</span>تومان
          </p>
          <v-btn role="button" v-ripple @click="modalCredit = true" class="mt-2" :class="$style['ma-2']"
                 style="background-color: #7ec352; border-radius: 20px; color: #fff !important;">
            افزایش اعتبار
          </v-btn>
        </div>
      </div>
      <div :class="$style['contentProfile']">
        <div :class="$style['itemsProfile']">
          <ul>
            <li :class="$style['itemProfile']">
              <router-link v-ripple v-on:click.native="redirect('edit-profile')" to="">
                <div :class="$style['itemInfo']">
                  <v-icon>account_circle</v-icon>
                  <span :class="$style['item']"> پروفایل کاربری </span>
                </div>
                <v-icon>arrow_back_ios</v-icon>
              </router-link>
            </li>
            <li :class="$style['itemProfile-sub']"></li>
            <li :class="$style['itemProfile']">
              <router-link v-ripple v-on:click.native="redirect('address')" to="">
                <div :class="$style['itemInfo']">
                  <v-icon>list</v-icon>
                  <span :class="$style['item']">آدرس های منتخب من</span>
                </div>
                <v-icon>arrow_back_ios</v-icon>
              </router-link>
            </li>
            <li :class="$style['itemProfile-sub']"></li>
            <li :class="$style['itemProfile']">
              <router-link v-ripple v-on:click.native="redirect('transactions')" to="">
                <div :class="$style['itemInfo']">
                  <v-icon>payment</v-icon>
                  <span :class="$style['item']">تراکنش مالی</span>
                </div>
                <v-icon>arrow_back_ios</v-icon>
              </router-link>
            </li>
            <li :class="$style['itemProfile-sub']"></li>
            <li :class="$style['itemProfile']">
              <router-link v-ripple v-on:click.native="redirect('inbox')" to="">
                <div :class="$style['itemInfo']">
                  <v-icon>mail</v-icon>
                  <span :class="$style['item']"> صندوق پیام </span>
                </div>
                <v-icon>arrow_back_ios</v-icon>
              </router-link>
            </li>
            <li :class="$style['itemProfile-sub']"></li>
            <li :class="$style['itemProfile']">
              <router-link v-ripple v-on:click.native="callSupport" to="">
                <div :class="$style['itemInfo']">
                  <v-icon>error_outline</v-icon>
                  <span :class="$style['item']"> پشتیبانی </span>
                </div>
                <v-icon>arrow_back_ios</v-icon>
              </router-link>
            </li>
            <li :class="$style['itemProfile-sub']"></li>
            <li :class="$style['itemProfile']">
              <router-link v-ripple v-on:click.native="redirect('share')" to="">
                <div :class="$style['itemInfo']">
                  <v-icon>share</v-icon>
                  <span :class="$style['item']">معرفی به دوستان</span>
                </div>
                <v-icon>arrow_back_ios</v-icon>
              </router-link>
            </li>
            <li :class="$style['itemProfile-sub']"></li>
            <li :class="$style['itemProfile']">
              <router-link v-ripple v-on:click.native="redirect('about')" to="">
                <div :class="$style['itemInfo']">
                  <v-icon>error_outline</v-icon>
                  <span :class="$style['item']"> درباره ما </span>
                </div>
                <v-icon>arrow_back_ios</v-icon>
              </router-link>
            </li>
            <li :class="$style['itemProfile-sub']"></li>
            <!--                        <li :class="$style['itemProfile']">-->
            <!--                            <router-link v-ripple v-on:click.native="redirect('representation')" to="">-->
            <!--                                <div :class="$style['itemInfo']">-->
            <!--                                    <v-icon>star</v-icon>-->
            <!--                                    <span :class="$style['item']"> اخذ نمایندگی </span>-->
            <!--                                </div>-->
            <!--                                <v-icon>arrow_back_ios</v-icon>-->
            <!--                            </router-link>-->
            <!--                        </li>-->
            <!--                        <li :class="$style['itemProfile-sub']"></li>-->
            <li :class="$style['itemProfile']">
              <router-link v-ripple v-on:click.native="modalDownload = true" to="">
                <div :class="$style['itemInfo']">
                  <v-icon>android</v-icon>
                  <span :class="$style['item']"> نسخه اندروید اپلیکیشن </span>
                </div>
                <v-icon>arrow_back_ios</v-icon>
              </router-link>
            </li>
            <li :class="$style['itemProfile-sub']"></li>
            <li :class="$style['itemExit']" v-if="profile != null" role="button" v-ripple
                @click.stop="modalExit = true">
              <div :class="$style['itemInfo']">
                <v-icon>input</v-icon>
                <span :class="$style['item']">خروج از حساب كاربری</span>
              </div>
              <v-icon>arrow_back_ios</v-icon>
            </li>
            <li :class="$style['itemProfile-sub']" v-if="profile != null"></li>
          </ul>
        </div>
        <div :class="$style['itemsSocial']">
          <ul>
            <li :class="$style['logoSocial']" v-for="item in listSocial" :key="item.index">
              <a :href="item.social_url">
                <img :src="item.social_avatar" :alt="item.social_title"/>
              </a>
            </li>
          </ul>
        </div>
      </div>

    </div>
    <div class="d-flex flex-row align-items-center mt-3 mb-3">
      <a referrerpolicy="origin" target="_blank" class="enamad mr-auto ml-auto"
         href="https://trustseal.enamad.ir/?id=127510&amp;Code=wlDPRmk2laScuSIKlodx">
        <img
            loading="lazy"
            referrerpolicy="origin"
            src="https://Trustseal.eNamad.ir/logo.aspx?id=127510&amp;Code=wlDPRmk2laScuSIKlodx"
            alt="" style="cursor:pointer" id="wlDPRmk2laScuSIKlodx">
      </a>
    </div>
    <v-dialog v-model="modalCredit" transition="scroll-y-transition">
      <v-card :class="[$style.box_modal, $style.profile_css]">
        <v-text name="charge" :class="$style['headline-tv']">
          <h3>افزایش اعتبار کلانا</h3>
          <div :class="$style['backpages']" role="button" v-ripple @click="modalCredit = false">
            <span>بازگشت</span>
            <v-icon>keyboard_arrow_left</v-icon>
          </div>
        </v-text>
        <v-text-field
            :class="$style['text-modal']"
            color="#26c6da"
            placeholder="مبلغ شارژ حساب (به تومان)"
            v-model="amount"
        ></v-text-field>
        <v-text v-if="profile != null" name="balance" :class="$style['priceText']">
          <span>اعتبار فعلی شما</span>
          <h2>{{ oracle.format(profile.user_wallet) + " تومان" }}</h2>
        </v-text>
        <div :class="$style['btnAddprice']">
          <v-btn
              :class="$style['btn-accept']"
              to=""
              color="#26c6da"
              dark
              role="button" v-ripple @click="increasecredit">
            افزایش اعتبار
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalExit" transition="scroll-y-transition">
      <v-card :class="[$style.box_modal, $style.profile_css]">
        <v-text name="exit" :class="$style['headline-tv']">
          <h3>خروج از حساب کاربری</h3>
          <div :class="$style['backpages']" role="button" v-ripple @click="modalExit = false">
            <span>بازگشت</span>
            <v-icon>keyboard_arrow_left</v-icon>
          </div>
        </v-text>
        <p style="margin: 10px">
          در صورتی که مایل هستید از حساب کاربری خود خارج شوید، ادامه دهید.
        </p>
        <div :class="$style['btnAddprice']">
          <v-btn
              :class="$style['btn-accept']"
              to=""
              color="#26c6da"
              dark
              role="button" v-ripple @click="logout()">
            بله خارج میشوم
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalDownload" transition="scroll-y-transition">
      <v-card :class="[$style.box_modal, $style.profile_css]">
        <v-text name="exit" :class="$style['headline-tv']">
          <h3>دانلود نسخه نصبی اندروید</h3>
          <div :class="$style['backpages']" role="button" v-ripple @click="modalDownload = false">
            <span>بازگشت</span>
            <v-icon>keyboard_arrow_left</v-icon>
          </div>
        </v-text>
        <p style="margin: 10px">
          کاربر گرامی، جهت نصب برنامه نسخه اندروید کلانا، از روش های زیر وارد شوید.
        </p>
        <!--        <div :class="$style['btnAddprice']">-->
        <!--          <p-->
        <!--              :class="$style['btn-p']"-->
        <!--              role="button" v-ripple-->
        <!--              @click="redirect('https://play.google.com/store/apps/details?id=ir.cluna.android', true)">-->
        <!--            دانلود از گوگل پلی-->
        <!--          </p>-->
        <!--        </div>-->
        <div :class="$style['btnAddprice']">
          <p
              :class="$style['btn-p']"
              role="button" v-ripple @click="redirect('https://cafebazaar.ir/app/ir.cluna.android', true)">
            دانلود از کافه بازار
          </p>
        </div>
        <div :class="$style['btnAddprice']">
          <p
              :class="$style['btn-p']"
              role="button" v-ripple
              @click="redirect(androidLink, true)">
            دانلود مستقیم از سایت کلانا
          </p>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalEnter" transition="scroll-y-transition">
      <v-card :class="[$style.box_modal, $style.profile_css]">
        <v-text name="login" :class="$style['headline-tv']">
          <h3>ورود به حساب کاربری</h3>
          <div :class="$style['backpages']" role="button" v-ripple @click="modalEnter = false">
            <span>بازگشت</span>
            <v-icon>keyboard_arrow_left</v-icon>
          </div>
        </v-text>
        <p style="margin: 10px">
          برای استفاده کامل از امکانات برنامه لطفا حساب کاربری خود را فعال نمائید.
        </p>
        <div :class="$style['btnAddprice']">
          <v-btn
              :class="$style['btn-accept']"
              to=""
              color="#26c6da"
              dark
              role="button" v-ripple @click="modalEnter = false, modalLogin = true">
            ورود به حساب کابری
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalLogin" transition="scroll-y-transition">
      <v-card :class="[$style.box_modal, $style.profile_css]">
        <v-text name="" :class="$style['headline-tv']">
          <h3>به ما بپیوندید</h3>
          <div :class="$style['backpages']" role="button" v-ripple @click="modalLogin = false, this.isCode = false">
            <span>بازگشت</span>
            <v-icon>keyboard_arrow_left</v-icon>
          </div>
        </v-text>
        <p style="margin: 10px">
          کد فعالسازی در قالب پیامک به شماره شما ارسال خواهد شد
        </p>
        <div :class="$style['btnAddprice']">
          <v-text-field
              :class="$style['text-modal']"
              v-model="phone"
              :placeholder="isCode == true ? 'کد دریافت شده خود را وارد کنید' : 'شماره موبایل خود را وارد کنید' ">
          </v-text-field>
          <v-btn
              :class="$style['btn-accept']"
              color="#26c6da"
              dark
              role="button" v-ripple @click="login">
            {{ isCode == true ? 'تایید کد فعالسازی' : 'ارسال کد فعالسازی' }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalUsername" transition="scroll-y-transition" persistent>
      <v-card :class="[$style.box_modal, $style.profile_css]">
        <v-text name="" :class="$style['headline-tv']">
          <h3>نام و نام خانوادگی</h3>
          <div :class="$style['backpages']" role="button" v-if="usernameField.length > 0" v-ripple
               @click="modalUsername = false">
            <span>بازگشت</span>
            <v-icon>keyboard_arrow_left</v-icon>
          </div>
        </v-text>
        <p style="margin: 10px">
          جهت بهبود روند ثبت و پیگیری سفارش, لطفا نام و نام خانوادگی خود را وارد نمایید.
        </p>
        <div :class="$style['btnAddprice']">
          <v-text-field
              :class="$style['text-modal']"
              v-model="usernameField"
              @change="usernameFieldError = null"
              :error-messages="usernameFieldError"
              :error="usernameFieldError != null"
              :placeholder="'نام و نام خانوادگی خود را وارد کنید'">
          </v-text-field>
          <v-btn
              :class="$style['btn-accept']"
              color="#26c6da"
              dark
              role="button" v-ripple @click="setUsername">
            {{ 'ثبت و ذخیره' }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalBasket" transition="scroll-y-transition">
      <v-card :class="[$style.box_modal, $style.profile_css]">
        <v-text name="login" :class="$style['headline-tv']">
          <h3>تکمیل خرید</h3>
          <div :class="$style['backpages']" role="button" v-ripple @click="modalEnter = false">
            <span>بازگشت</span>
            <v-icon>keyboard_arrow_left</v-icon>
          </div>
        </v-text>
        <p style="margin: 10px">
          برای تکمیل سفارش خود وارد سبد خرید شوید!
        </p>
        <div :class="$style['btnAddprice']">
          <v-btn
              :class="$style['btn-accept']"
              to=""
              color="#7ec352"
              dark
              role="button" v-ripple @click="$router.push('/basket')">
            ورود به سبد خرید
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import oracle from "@/utils/oracle";

export default {
  name: "Profile",
  data() {
    return {
      androidLink: null,
      modalBasket: false,
      modalDownload: false,
      modalCredit: false,
      modalExit: false,
      modalEnter: false,
      modalLogin: false,
      modalUsername: false,
      tempModalBasket: false,
      isLoaded: false,
      usernameField: '',
      usernameFieldError: null,
      isCode: false,
      phone: '',
      phone_old: '',
      profile: null,
      avatar: "",
      tel: "",
      amount: "",
      listSocial: "",
      oracle: oracle
    };
  },
  methods: {
    setUsername() {
      if (this.usernameField == null || this.usernameField == "" || this.usernameField.trim() == "") {
        this.usernameFieldError = "لطفا نام و نام خانوادگی خود را به درستی وارد نمایید."
        return
      }
      const model = {username: this.usernameField};
      oracle.axios("user/edit", model, this.onSetUsername);
    },
    callSupport() {
      let link = "tel:" + this.tel
      window.open(link, '_blank');
    },
    onSetUsername() {
      this.checkUser()
      this.modalUsername = false
      this.modalBasket = this.tempModalBasket;
    },
    redirect(id, newTab) {
      if (newTab != null && newTab) {
        window.open(id, '_blank');
      } else {
        if (oracle.getToken() == null) {
          this.modalEnter = true
        } else {
          this.$router.push('/' + id)
        }
      }
    },
    login() {
      if (this.isCode == true) {
        let model = {"captcha": this.phone, "phone": this.phone_old}
        oracle.axios("user/verify", model, this.endVerify);
      } else {
        let model = {"phone": this.phone}
        oracle.axios("user/authenticate", model, this.verify);
      }
    },
    verify() {
      this.isCode = true
      this.phone_old = this.phone
      this.phone = ''
    },
    endVerify() {
      this.isCode = false
      this.phone = ''
      this.modalLogin = false
      this.checkUser()
      let redirectToBasket = false
      if (oracle.getShop() && oracle.getBasket() && oracle.getBasket().length > 0) {
        redirectToBasket = true
      }
      if (!this.checkIfUserNameIsEmpty(redirectToBasket)) {
        this.modalBasket = redirectToBasket
      }
    },
    checkIfUserNameIsEmpty(redirectToBasket) {
      if (oracle.getToken() != null) {
        oracle.axios("user/getProfile", null, (res) => {
          if (res.data.username == null || res.data.username.trim() == "" || res.data.username == ".") {
            this.tempModalBasket = redirectToBasket
            this.usernameField = ''
            this.modalUsername = true
          } else {
            this.modalBasket = redirectToBasket
          }
        });
      }
    },
    logout() {
      this.modalExit = false;
      oracle.logOut()
      this.checkUser()
    },
    onFileChange(e) {
      let file = e.target.files[0];
      oracle.axiosUpload(file, this.uploadFile);
    },
    uploadFile(res) {
      const model = {user_avatar: res.data};
      oracle.axios("user/edit", model, this.checkUser());
    },
    increasecredit() {
      oracle.axios(
          "payment/create",
          {
            payment_type: 0,
            payment_amount: this.amount,
            payment_tag: "https://pwa.cluna.app/profile"
          },
          (res) => {
            window.location.href = res.data.payment_url
          }
      );
    },
    checkUser() {
      if (oracle.getToken() != null) {
        oracle.axios("user/getProfile", null, (res) => {
          this.profile = res.data;
          this.isLoaded = true;
        });
      } else {
        this.profile = null
        this.isLoaded = true;
      }
    }
  },
  mounted() {
    oracle.axios("social/getList", null, (res) => {
      this.listSocial = res.data;
    });
    oracle.axios("setting/getInfo", {"filter_by": "website", 'search_by': 'android_link'}, (res) => {
      this.androidLink = res.data;
    });
    oracle.axios("setting/getInfo", {"filter_by": "website", 'search_by': 'support'}, (res) => {
      this.tel = res.data;
    });
    this.checkUser()
    if (this.$route.query.login != null && oracle.getToken() == null) {
      this.modalLogin = true
    }
  }
};
</script>
<style module>

.registrProfile {
  margin-bottom: 15px;
  margin-top: 15px;
}

.target_profile_height {
  height: calc(100vh - 76px);
  overflow: auto;
}

.profile_css .item {
  margin-top: auto !important;
  margin-bottom: auto !important;
  margin-right: 10px;
  font-size: 14px !important;
  color: #555;
}

.profile_css .Profile {
  height: 100%;
  overflow: scroll;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.profile_css .border_r {
  height: auto !important;
  margin-top: 10px;
  margin-bottom: 10px;
}

.ma-2 {
  margin-bottom: 20px;
}

.profile_css .logoProfile {
  width: 90px;
  height: 90px;
  margin-bottom: 15px;
}

.profile_css .center_cropped {
  width: 90px;
  height: 90px;
  background-position: center center;
  background-repeat: no-repeat;
  object-fit: none;
  object-position: center;
  background-size: cover;
  border-radius: 50%;
}

.profile_css .center_cropped_main {
  background-position: center center;
  background-repeat: no-repeat;
  object-fit: none;
  object-position: center;
  background-size: cover;
}

.profile_css .logoProfile img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile_css .headerProfile {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.profile_css .headerProfile {
  background-image: url("../assets/image/cluna/ic_profile_wall.png");
}

.profile_css .textProfile h6 {
  font-size: 20px;
  padding-top: 10px;
  font-weight: bold;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
}

.profile_css .textProfile span {
  color: #000;
  text-align: center;
  font-size: 15px;
  padding: 0 0;
  margin-bottom: 10px;
  margin-right: auto;
  margin-left: auto;
}

.profile_css .textProfile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
}

.profile_css .itemProfile-sub {
  border-bottom: 2px solid #dbd9d9;
  margin-right: 13%;
}

.profile_css .itemProfile a,
.profile_css .itemExit {
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  color: #000;
}

.profile_css .titleModalExit {
  color: #707070 !important;
  font-size: 12px;
  text-align: center;
  padding: 15px;
}

.profile_css .itemProfile a .v-icon,
.profile_css .itemExit .v-icon {
  color: #000;
  font-size: 15px;
}

.profile_css .itemInfo .v-icon {
  color: #acaca8 !important;
  font-size: 22px !important;
  padding-left: 10px;
}

.profile_css .itemInfo span {
  font-size: 12px;
  font-weight: bold;
}

.profile_css .itemInfo {
  display: flex;
}

.profile_css .itemsProfile {
  margin-top: 20px;
  max-height: 65vh;
  overflow: auto;
  margin-bottom: 1em;
}

.profile_css .itemsSocial {
  margin-bottom: 10px;
}

.profile_css .itemsSocial ul {
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
}

.profile_css .itemsSocial li {
  margin-right: 10px;
}

.profile_css .logoSocial {
  width: 25px;
  height: 25px;
  border-radius: 50px;
  overflow: hidden;
}

.profile_css .logoSocial img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile_css .uploadAvatar {
  position: absolute;
  right: 2px;
  bottom: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  background: #fff;
}

.profile_css .uploadAvatar .v-icon {
  font-size: 30px !important;
  color: #ffeb3b !important;
}

.profile_css .contentProfile {
  max-height: 55%;
  margin-bottom: 20px;
}

.uploaduser {
  width: 0;
  height: 0;
  opacity: 0;
}

.profile_css .profileAvatar {
  width: 100px;
  /*height: 80px;*/
  display: flex;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  top: 12px;
  /*margin-bottom: 1.5em;*/
  z-index: 10;
}

.profile_css .modalExit {
  padding: 15px;
}

.profile_css .v-card__text {
  text-align: center;
}

.profile_css .btnExit {
  background: #356ac5;
}

.profile_css .btn-profile {
  display: flex;
  justify-content: space-between;
}

.profile_css .btn-profile button {
  font-size: 13px !important;
}

.profile_css .loading {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile_css .Profile .v-application--wrap {
  background: #fff !important;
}

.profile_css .text-modal {
  margin-left: 10px !important;
  margin-right: 10px !important;
}

.profile_css .increase-credit span {
  font-size: 15px;
  padding: 0 5px;
}

.profile_css .increase-credit {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  font-size: 13px;
}

.profile_css .increase-credit .v-icon {
  color: #ffffff;
  font-size: 20px;
  padding-left: 5px;
}

.profile_css .increase-credit p {
  margin: 0;
}

.profile_css .box_modal {
  padding: 10px 15px;
}

.profile_css .box_modal input::placeholder {
  font-size: 12px;
}

.profile_css .headline-tv {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.profile_css .headline-tv span {
  font-size: 12px !important;
  font-weight: bold;
}

.profile_css .backpages,
.profile_css .backpages .v-icon {
  color: #a8b1ae;
  display: flex;
  align-items: center;
  font-weight: 100;
}

.profile_css .backpages .v-icon {
  font-size: 20px !important;
}

.profile_css .backpages span {
  font-weight: 100;
}

.profile_css .priceText {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  font-size: 12px;
}

.profile_css .priceText span:last-child {
  color: #000;
  font-weight: bold;
}

.profile_css .btnAddprice button {
  margin: 15px 0;
  background: #26c6da !important;
  color: #fff !important;
  width: 100%;
}

.profile_css .btn-accept {
  width: 80%;
}

.profile_css .item-credit h5 {
  color: #ffffff;
  font-size: 13px;
}

.profile_css .item-credit {
  display: flex;
  background-color: #7ec352;
  border-radius: 20px;
  padding: 5px;
  margin-bottom: 15px;
}

.profile_css .btnAddprice button {
  margin-bottom: 0;
}

.profile_css input {
  text-align: center !important;
}

.box_modal input {
  text-align: center !important;
}

.profile_css .btn-p {
  background-color: #7dc353;
  text-align: center;
  color: white;
  margin-bottom: 0;
  padding: 5px;
  border-bottom: white 1px solid;
}
</style>
<style>
.enamad {
  margin-right: auto;
  margin-left: auto;
  text-align: center;
}

.enamad img {
  margin-right: auto;
  text-align: center;
  margin-left: auto;
  width: 100px;
  height: 100px;
  max-width: 100px;
  min-width: 100px;
  max-height: 100px;
  min-height: 100px;
}
</style>
